// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ContentProvider } from "./context/ContentProvider"; 
import { BrowserRouter } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ContentProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ContentProvider>
);
